/** @format */

import {useReducer} from 'react'

import {FieldType} from '../FieldType'

export type State =
  | {step: 'Choose type to add'}
  | {
      step: 'Configure validation parameters'
      fieldType: FieldType
    }

type Action =
  | {
      is: 'Select field type'
      params: {
        fieldType: FieldType
      }
    }
  | {is: 'Reset'}

export function useAddFieldState() {
  return useReducer(reducer, initialState)
}

function reducer(state: State, action: Action): State {
  // handle for any steps
  if (action.is === 'Reset') {
    return {...initialState}
  }

  if (
    state.step === 'Choose type to add' &&
    action.is === 'Select field type'
  ) {
    return {
      step: 'Configure validation parameters',
      fieldType: action.params.fieldType,
    }
  }

  return state
}

const initialState: State = {step: 'Choose type to add'}
